import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const updateUserSpecialty = async (profileId, specialty) => {
  try {
    console.log('Updating specialty for profile:', profileId);
    
    const input = {
      id: profileId,
      chosenSpecialty: specialty,
      specialtyUpdatedAt: new Date().toISOString()
    };

    const result = await client.graphql({
      query: mutations.updateUserProfile,
      variables: { input },
      authMode: 'userPool'
    });

    console.log('Update successful:', result);
    return result;
  } catch (error) {
    console.error('Error updating specialty:', error);
    throw error;
  }
};
